import React from 'react';

import 'intl';
import 'intl/locale-data/jsonp/en';
import 'intl/locale-data/jsonp/ja';

import {I18nProvider} from '@wheeebo/polaris-ui';

import ja from '@i18n/ja.json';
import en from '@i18n/en.json';

const SUPPORTED_LOCALES = ['en', 'ja'];
const DEFAULT_LOCALE = SUPPORTED_LOCALES[0];
const getLocale = (): string => {
  const languageCode = navigator.language.split(/[-_]/)[0];
  return SUPPORTED_LOCALES.includes(languageCode) ? languageCode : DEFAULT_LOCALE;
};

const getMessages = (locale: string): {[key: string]: string} => {
  switch (locale) {
    case 'en':
      return en;
    case 'ja':
      return {
        ...getMessages('en'),
        ...ja,
      };
    default:
      return en;
  }
};

interface Props {
  children: React.ReactNode;
}

export const IntlProviderWrapper = ({children}: Props) => {
  const locale = getLocale();
  return (
    <I18nProvider locale={locale} messages={getMessages(locale)}>
      {children}
    </I18nProvider>
  );
};
